var React = require('react');

function Github (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-github","d":"M10.9,2.1A9.959,9.959,0,0,0,9,21.5V19.2a4.126,4.126,0,0,1-.9.1A2.157,2.157,0,0,1,6,17.4a2.075,2.075,0,0,0-.6-1c-.3-.1-.4-.1-.4-.2,0-.2.3-.2.4-.2.6,0,1.1.7,1.3,1a1.822,1.822,0,0,0,1.4,1,2,2,0,0,0,.9-.2A2.534,2.534,0,0,1,10,16c-2.3-.5-4-1.8-4-4A4.713,4.713,0,0,1,7.2,9,3.709,3.709,0,0,1,7,7.6,3.427,3.427,0,0,1,7.3,6a4.5,4.5,0,0,1,2.8,1.3A5.412,5.412,0,0,1,12,7a6.448,6.448,0,0,1,2,.3A4.311,4.311,0,0,1,16.8,6,4.97,4.97,0,0,1,17,7.6,3.325,3.325,0,0,1,16.8,9,4.505,4.505,0,0,1,18,12c0,2.2-1.7,3.5-4,4a3.083,3.083,0,0,1,1,2.3v3.3A10.011,10.011,0,0,0,10.9,2.1Z","transform":"translate(-2.026 -2.031)","fill":"#81e6d9"}));
}

Github.defaultProps = {"width":"19.974","height":"19.569","viewBox":"0 0 19.974 19.569"};

module.exports = Github;

Github.default = Github;
